//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Plate from './_plate'
import Score from './_score'
import Card from './_card'
import Info from './_info'
import Condition from './_condition'
import Facilities from './_facilities'
import Price from './_price'
import JoinGroup from './_join_group'
const CATEGORIES = ["综合评星", "宜居指数", "期待指数", "关注指数"]
const PRICE_KEYS = ['last_house', 'plate_presale', 'secondhand_house', 'land_trade']

export default {
    props: {
        purchase_qualification: Array,
        price_compares: Object,
        show_consultant_footer: Boolean,
        items: Array,
        building_id: [String, Number],
        building_name: String,
        building_info: Array,
        general_ratings: Object,
        house: Object,
        excellent_consultants: Array
    },
    data () {
        return {
            tips_content: '',
            show_tips_modal: false
        }
    },
    computed: {
        price () {
            const res = {}
            const keys = Object.keys(this.price_compares || {})
            if (keys.length) {
                PRICE_KEYS.forEach(key => {
                    const item = this.price_compares[key]
                    if (item) {
                        switch (key) {
                            case 'last_house':
                                item['name'] = item['history_lottery'] ? '该楼盘上批次价格' : '该楼盘本批次价格'
                                item['link_tx'] = item['history_lottery'] ? '上批次一房一价' : '本批次一房一价价格'
                                item['link'] = `/building/price?building_id=${this.building_id}&house_id=${item.house_id}`
                                break
                            case 'land_trade':
                                item['name'] = "同板块最近土拍成交价"
                                item['link_tx'] = '土拍详情'
                                // item['link'] = `/packageA/trade_data/auction/detail?id=${item.land_trade_id}`
                                break
                            case 'plate_presale':
                                item['name'] = "同板块近三月取证价格"
                                item['link_tx'] = '板块房价'
                                item['link'] = `/packageB/plates/main?id=${item.plate_id}`
                                break
                            case 'secondhand_house':
                                item['name'] = "区域内周边二手房参考价"
                                item['link_tx'] = '二手房参考价'
                                // item['link'] = `/pages/packageB/guide_price/main`
                                break
                        }
                        res[key] = item
                    }
                })
                return res
            }
            return null
        },
        traffics () {
            const { details = {}, rating } = this.getItem('traffics')
            const { metro = {} } = details
            return {
                metro,
                rating,
            }
        },
        educations () {
            const { details = {}, rating } = this.getItem('educations')
            const default_val = {
                count: 0,
                radius: '3km'
            }
            const _schools = ['幼儿园', '小学', '中学'].map(item => {
                const _item = details[item] || default_val
                return {
                    ..._item,
                    label: item
                }
            })
            const show_educations_details = _schools.some(item => item.count > 0)
            const radius = _schools[0].radius
            const count_max = _schools.reduce((prev, { count }) => {
                prev = prev.concat(count)
                return prev
            }, []).reduce((prev, cur) => {
                return Math.max(prev, cur)
            }, 0)
            const schools = _schools.map(item => {
                const { count } = item
                item.h = (count / count_max) * 100 + '%'
                return item
            })
            return {
                show_educations_details,
                rating,
                radius,
                schools
            }
        },
        lives () {
            const { details = {}, rating } = this.getItem('lives')
            const default_val = {
                count: 0,
                radius: '5km'
            }
            const labels = {
                hospital: {
                    name: '医院',
                    nickname: '医院'
                },
                shopping: {
                    name: '购物点',
                    nickname: '商场'
                }
            }
            const lifes = Object.keys(labels).map(item => {
                const _item = details[item] || default_val
                return {
                    ..._item,
                    label: labels[item]
                }
            })
            const compare_content = lifes.map(item => {
                const { label } = item
                const { name } = label
                return `${item.count || 0}个${name}`
            })
            const show_lifes = lifes.some(item => Number(item.count) > 0)
            return {
                lifes,
                compare_content,
                rating,
                show_lifes
            }
        },
        environments () {
            const { details = {}, rating } = this.getItem('environments')
            const { park = {} } = details
            return {
                park,
                rating
            }
        },
        plate () {
            const { details = {} } = this.getItem('plate')
            const { ratings = {} } = details
            const _ratings =  CATEGORIES.filter(item => ratings[item]).map(item => {
                return {
                    name: item,
                    value: ratings[item]
                }
            })
            return {
                ...details,
                ratings: _ratings,
                show_plate: _ratings.length > 0
            }
        },
        show_vr_panorama () {
            return this.house.vr_panorama_resource && Boolean(this.house.vr_panorama_resource.vr_panorama_url)
        }
    },
    methods: {
        getItem(category) {
            return this.items?.filter(item => item.category === category)[0] || {}
        },
        goConsultant() {
            wx.navigateTo({
                url: `/consultants/filter/main?id=${this.building_id}`
            })
        },
        show_tips (content) {
            this.show_tips_modal = true
            this.tips_content = content
        },
        hide_tips () {
            this.show_tips_modal = false
        }
    },
    components: {
        JoinGroup,
        Price,
        Facilities,
        Condition,
        Info,
        Card,
        Plate,
        Score
    }
}
